import { getToken } from "firebase/messaging";
import { getFirebaseMessaging } from "../firebase";

const getFirebaseEnv = () => ({
  REACT_APP_FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  REACT_APP_FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
  REACT_APP_FIREBASE_VAPID_KEY: process.env.REACT_APP_FIREBASE_VAPID_KEY,
});

const validateEnv = () => {
  const env = getFirebaseEnv();
  const missing = Object.keys(env).filter((key) => !env[key]);

  if (missing.length > 0) {
    console.error("FCM: Missing environment variables:", missing);
    return false;
  }
  return true;
};

let messagingPromise = null;
const getMessagingInstance = async () => {
  if (!messagingPromise) {
    messagingPromise = getFirebaseMessaging().catch((err) => {
      messagingPromise = null;
      throw err;
    });
  }
  return messagingPromise;
};

export const generateFcmToken = async () => {
  try {
    if (typeof window === "undefined" || !("Notification" in window)) {
      return null;
    }

    if (!validateEnv()) return null;

    const messaging = await getMessagingInstance();
    if (!messaging) return null;

    let permission = Notification.permission;
    if (permission !== "granted") {
      permission = await Notification.requestPermission();
    }

    if (permission !== "granted") {
      console.warn("FCM: Notification permission not granted");
      return null;
    }

    let serviceWorkerRegistration;
    if ("serviceWorker" in navigator) {
      try {
        const swUrl = new URL("/firebase-messaging-sw.js", window.location.origin);
        swUrl.searchParams.set("apiKey", process.env.REACT_APP_FIREBASE_API_KEY);
        swUrl.searchParams.set("authDomain", process.env.REACT_APP_FIREBASE_AUTH_DOMAIN);
        swUrl.searchParams.set("projectId", process.env.REACT_APP_FIREBASE_PROJECT_ID);
        swUrl.searchParams.set("messagingSenderId", process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID);
        swUrl.searchParams.set("appId", process.env.REACT_APP_FIREBASE_APP_ID);

        serviceWorkerRegistration = await navigator.serviceWorker.register(swUrl.toString(), {
          scope: "/",
        });
        await navigator.serviceWorker.ready;
      } catch (swError) {
        console.error("FCM: Service Worker registration failed:", swError);
        return null;
      }
    }

    const token = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY,
      serviceWorkerRegistration,
    });

    if (process.env.NODE_ENV !== "production") {
      console.log("FCM: Token generated successfully");
    }

    return token || null;
  } catch (error) {
    console.error("FCM: Token generation failed:", error);
    return null;
  }
};

export const onForegroundMessage = async (callback) => {
  if (typeof window === "undefined") return () => {};
  try {
    const messaging = await getMessagingInstance();
    if (!messaging) return () => {};
    const { onMessage } = await import("firebase/messaging");
    return onMessage(messaging, callback);
  } catch (error) {
    console.error("FCM: Error registering foreground message listener:", error);
    return () => {};
  }
};